import actions from './actions'

const initialState = {
  loading: false,
}

export default function create(state = initialState, action) {
  switch (action.type) {
    case actions.CREATE_REQUEST:
      return {
        ...state,
        loading: true,
      }
    case actions.CREATE_SUCCESS:
      return {
        ...state,
        ...action.payload,
        loading: false,
      }
    case actions.CREATE_ERROR:
      return {
        ...initialState,
        ...action.payload,
      }
    case actions.CREATE_RESET:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
